import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { apiGet, apiPost, apiDelete, apiPut } from "./api/server"

const FlowchartsView = () => {
  const [renderText, setRenderText] = useState("graph TD\nA --> B");
  const [flowcharts, setFlowcharts] = useState([])
  const [currentChart, setCurrentChart] = useState(0)
  const [currentChartName, setCurrentChartName] = useState("(New)")
  const [fullScreen, setFullScreen] = useState(false)
  const [showModal, setShowModal] = useState(false);

  const deleteFlowchart = () => {
    //TODO
    if (!currentChart || currentChart < 1) {
        setShowModal(false); // Close the modal after deletion
    } else {
      apiDelete("intranetflowcharts/deleteflowchart", {
        id: currentChart
      }).then(res => {
        res.json().then(data => {
          updateFlowcharts();
          const keepTitle = currentChartName+"";
          const keepMarkdown = renderText+"";
          setCurrentChart(0)
          setTimeout(() => {
            setCurrentChartName(keepTitle);
            setRenderText(keepMarkdown);
          }, 500);
          setShowModal(false); // Close the modal after deletion
        })
      })
    }
  };

  const updateFlowcharts = async function () {
    let res = await apiGet("intranetflowcharts/getflowcharts")
    res = await res.json()
    let _default = {
      id: 0,
      name: "(New)",
      markdown: "graph TD\nA --> B",
      hidden: false
    }
    setFlowcharts([_default, ...res])
  }

  const saveChart = async function () {
    if (!currentChart || currentChart < 1) {
      // New Chart
      if (currentChartName && renderText) {
        let res = await apiPost("intranetflowcharts/createflowchart", {
          name: currentChartName,
          markdown: renderText,
          hidden: false
        })
        res = await res.json()
        await updateFlowcharts();
        setCurrentChart(res[0].id)
      }
    } else {
      // Existing Chart
      if (currentChartName && renderText) {
        apiPut("intranetflowcharts/updateflowchart", {
          id: currentChart,
          name: currentChartName,
          markdown: renderText,
          hidden: false
        }).then(res => {
          res.json().then(res2 => {
            console.log(res2)
            updateFlowcharts();
          })
        })
      }
    }
  }
  

  useEffect(() => {
    // Switching Charts
    if (!currentChart || currentChart < 1) {
      setRenderText("graph TD\nA --> B")
      setCurrentChartName("")
    } else {
      let chart = flowcharts.filter((v) => v.id == currentChart)[0]
      setRenderText(chart.markdown)
      setCurrentChartName(chart.name)
    }
  }, [currentChart])

  useEffect(() => {
    updateFlowcharts()
  }, []);

  useEffect(() => {
    const head = document.getElementsByTagName("head")[0];
    const style = document.createElement("style");
    style.innerHTML = ".mermaid .label,.mermaid text,.mermaid .node text { text-transform: none !important; }"
    head.appendChild(style);
  }, []);

  // https://stackoverflow.com/questions/34424845/adding-script-tag-to-react-jsx
  // Add and remove script to reload when renderText changes
  useEffect(() => {
    console.log(renderText)
    console.log(JSON.stringify(renderText))
    const script = document.createElement("script");
    script.type = "module";
    script.innerHTML = `
      import mermaid from 'https://cdn.jsdelivr.net/npm/mermaid@11.4.1/dist/mermaid.esm.min.mjs';
      mermaid.initialize({ startOnLoad: true });
      mermaid.registerIconPacks([
  {
    name: 'logos',
    loader: () =>
      fetch('https://unpkg.com/@iconify-json/logos@1/icons.json').then((res) => res.json()),
  },
  {
    name: 'ic',
    loader: () =>
      fetch('https://unpkg.com/@iconify-json/ic@1/icons.json').then((res) => res.json()),
  },
]);
      try {
        // Validate Mermaid syntax
        console.log(mermaid.parse(${JSON.stringify(renderText)}, {suppressErrors: true}))
        if (await mermaid.parse(${JSON.stringify(renderText)}, {suppressErrors: true})) {
          mermaid.run();
        }
      } catch (error) {
        console.log("Invalid Mermaid syntax:", error);
      }
    `;
    document.body.appendChild(script);
    

    return () => {
      document.body.removeChild(script);
    };
  }, [renderText]);

  return (
    <Container>
      <Row>
        <Col xs={(fullScreen ? 12 : 6)}>
          <h1>Mermaid Diagram</h1>
          <a href="https://mermaid.js.org/syntax/flowchart.html">Flowchart Help</a>
          <br/>
          <a href="https://icon-sets.iconify.design/">Icon Search</a>
          <br/>
          <a href="https://mermaid.live">Live Editor (can export as image)</a>
          <h3>{currentChartName}</h3>
          <div key={renderText} className="mermaid" style={{ whiteSpace: "pre-line" }}>
            {renderText}
          </div>
        </Col>
        <Col xs={6}>
        <Row>
          <Col>
            <Form>
              <Form.Group controlId="flowchartsList">
                <Form.Control
                  as="select"
                  value={currentChart}
                  onChange={(e) => setCurrentChart(e.target.value)}
                  >
                  {
                    flowcharts.map((v) => {
                      return <option value={v.id}>{v.name}</option>
                    })
                  }
                </Form.Control>
              </Form.Group>
              <Form.Group controlId="fullScreen">
                <Form.Check
                  type={"checkbox"}
                  checked={fullScreen}
                  onChange={(e) => setFullScreen(e.target.checked)}
                  label={"Fullscreen?"}
                  />
              </Form.Group>
            </Form>
          </Col>
        </Row>
        <Form>
        <Row>
          <Col xs={8}>
              <Form.Group controlId="charttitle">
                <Form.Control
                  as="input"
                  value={currentChartName}
                  onChange={(e) => setCurrentChartName(e.target.value)}
                  style={{maxWidth: "100%"}}
                ></Form.Control>
              </Form.Group>
          </Col>
          <Col>
            <Button onClick={() => {saveChart();}}>
              Save
            </Button>
          </Col>
          <Col>
            <Button onClick={() => setShowModal(true)}>
              Delete
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
              <Form>
                <Form.Group controlId="rendertext">
                  <Form.Control
                    as="textarea"
                    rows={20}
                    value={renderText}
                    onChange={(e) => setRenderText(e.target.value)}
                    style={{maxWidth: "100%"}}
                  ></Form.Control>
                </Form.Group>
              </Form>
            </Col>
          </Row>
          </Form>
        </Col>
      </Row>
      <Modal show={showModal} onHide={()=>setShowModal(false)} >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this item? This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={()=>setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={()=>deleteFlowchart()}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default FlowchartsView;
